// @ts-nocheck

import { useHistory } from 'react-router';
import {
  setMarkerParams,
  processTailoredRegionMarkers,
  processBookingData,
  makeLowerCase,
  isEmpty,
  calculatePriceTiers,
  getBoundedListings,
  getFilteredListings,
  getVisibleListings,
  convertBoundsArrayToObj,
  isLeapYear,
  fetchMonthlyHistoricalData,
  processMonthlyHistoricalData,
  brightConsole,
  parseMessageHistoricalData,
  storeVisitedMarketInLocalStorage,
  removeAccent,
  syncLocalstorageMarketSearchHistory,
} from 'src/utils/functions';
import {
  GET_SEARCH_LOAD_END,
  GET_SEARCH_LOAD_START,
  GET_TAILORED_REGION_MARKERS_SUCCESS,
  GET_REVIEW_STREAM_LOAD_START,
  GET_REVIEW_STREAM_LOAD_END,
  SEARCH_CHANGE,
  SET_USER_INFO,
  GET_COMPSETS_LOAD_START,
  GET_COMPSETS_LOAD_END,
  GET_COMPSET_LOAD_START,
  GET_COMPSET_LOAD_END,
  GET_COMPSET_LISTING_IDS_LOAD_START,
  GET_COMPSET_LISTING_IDS_LOAD_END,
  SET_IS_USER_ALLOWED,
  GET_USER_AIRBNB_LISTINGS_LOAD_START,
  GET_USER_AIRBNB_LISTINGS_LOAD_END,
  GET_LISTING_PRICING_RECOMMENDATION_LOAD_START,
  GET_LISTING_PRICING_RECOMMENDATION_LOAD_END,
  SET_CURRENCY,
  SET_SEARCH_LIMIT_BOX_ALERT,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END,
  SET_REV_POTENTIAL_RANGE_INVESTMENT,
  EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  SET_BOUNDS_MAP_INSIGHTS,
  SET_FILTERS_INSIGHTS,
  SET_FILTER_INSIGHTS_ACTIVE,
  SET_USER_COUNTRY_CODE,
  SET_USER_PREF_COUNTRY_CODE,
  SET_INDIVIDUAL_REV_POTENTIAL_RANGE,
  SET_HISTORICAL_DATA,
  SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR,
  GET_CACHED_SEARCH_MARKETS,
  SET_AIRBTICS_PRO_BANNER_VISIBLE,
  SET_TOP_BANNER_OPEN,
  SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE,
  SET_SEARCHED_MARKET_ESTIMATOR,
  SET_MARKET_CACHED_DATA,
  GET_MARKET_CACHED_DATA,
  SET_MARKET_DASHBOARD_FILTER_DATA,
  SET_PRICE_TIERS,
  UPDATE_PRICE_TIERS,
  SET_EXPLORER_MARKETS,
  GET_EXPLORER_MARKETS,
  SET_LOCKED_MARKET_DUMMY_DATA,
  SET_IS_CACHED_MARKET_DATA_SAMPLE,
  SET_LEAD_FORM_SOURCE,
  DEDUCT_ESTIMATOR_CREDIT,
  SET_USED_VERIFIED,
  SET_VISIBLE_LISTING_IDS,
  GET_VISIBLE_MAP_SUPPLY_LOAD_START,
  SET_VISIBLE_MAP_SUPPLY,
  SET_TOP_10_MARKETS_COUNTRY_WISE,
  SET_TOP_HOSTS,
  SET_HIDDEN_SUBMARKETS,
  GET_HIDDEN_SUBMARKETS_LOAD_START,
  GET_CLUSTERS_LOAD_START,
  GET_CLUSTERS_LOAD_END,
  GET_MARKET_CACHED_DATA_WITH_FILTERS,
  SET_MARKET_CACHED_DATA_WITH_FILTERS,
  SET_NO_DATA_WITH_CURRENT_FILTER,
  GET_MAP_OVERVIEW_KPI_LOAD_START,
  SET_MAP_OVERVIEW_KPI,
  SET_SELECTED_LIST,
  SET_LAST_SAVED_MARKET_NAMES,
  SET_OPEN_SAVED_MARKETS_CTA_MODAL,
  SELECTED_LIST_LOADING,
  SET_SELECTED_LIST_ERROR,
  SET_ALL_SAVED_MARKET_LISTS,
  SET_ALL_SAVED_MARKET_LISTS_LOADING,
  UPDATE_LIST_MARKETS_COUNT_IN_ALL_SAVED_MARKET_LISTS,
  UPDATE_USER_MARKET_EXPLORER_ROW_DATA_EXPORT_USAGE,
  GET_MARKET_GRADE_LOAD_START,
  SET_MARKET_GRADE,
  SET_MARKET_GRADE_ERROR,
  SET_MARKET_GRADE_404_ERROR,
  UPDATE_USER_MARKET_SUMMARY_PDF_EXPORT_USAGE,
  GET_MARKETS_IN_MAP_VIEWPORT_LOAD_START,
  SET_MARKETS_IN_MAP_VIEWPORT,
  SET_CACHED_MARKET_DATA_RATE_LIMITED,
  SET_MAP_LISTINGS_RATE_LIMITED,
  SET_TOP_HOSTS_RATE_LIMITED,
  SET_TAILORED_REGION_CREATION_RATE_LIMITED,
  SET_LAST_PERFORMANCE_PROCESSED_MONTH,
} from 'src/store/Dashboard/types';
import {
  Listing,
  Search,
  Graph,
  ReviewStream,
  RateAndAvailChanges,
  TailoredRegionMarkers,
  NearbyRecommendedMarket,
  CachedSearchedMarketsType,
  FilteredListingsDashboardDataType,
  PriceTiers,
  Bounds,
} from '../../interfaces/idashboard';
import { User } from '../../interfaces/iuser';
import { AppDispatch } from '../../core/StoreProvier/StoreProvider';
import { CompsetFilterVal } from 'src/interfaces/iproptypes';
import {
  OVERVIEW_DASHBOARD_FILTER_DEMO_DATA,
  daysInMonth,
  sampleMarket,
  DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE,
  GET_TOP_HOST_DETAILS_URL,
  SAVED_MARKETS_POPUP_MESSAGE_THRESHOLD,
  LAST_SELECTED_MARKET_LIST_ID,
} from 'src/utils/const';
// import demoGranularDataDaily from 'src/demoGranularDataDaily';
import { callApi } from 'src/core/callApi';
import pako from 'pako';
import Fuse from 'fuse.js';
import axios from 'axios';
import { deepCopyObject } from 'src/utils/functions';
import FIFOAsyncQueue from '../middleware/FifoAsyncQueue';

const getTailoredRegionMarkersSuccess = (payload: TailoredRegionMarkers[]) => ({
  type: GET_TAILORED_REGION_MARKERS_SUCCESS,
  payload,
});

export const getSearchLoadStart = () => ({
  type: GET_SEARCH_LOAD_START,
});

export const getSearchLoadEnd = () => ({
  type: GET_SEARCH_LOAD_END,
});

const getReviewStreamLoadStart = () => ({
  type: GET_REVIEW_STREAM_LOAD_START,
});

const getReviewStreamLoadEnd = (payload: ReviewStream) => ({
  type: GET_REVIEW_STREAM_LOAD_END,
  payload,
});

export const setEstimatorSearchedMarket = payload => ({
  type: SET_SEARCHED_MARKET_ESTIMATOR,
  payload,
});

export const setUserInfo = (payload: User) => ({
  type: SET_USER_INFO,
  payload,
});

export const getCompsetListingIdsLoadStart = () => ({
  type: GET_COMPSET_LISTING_IDS_LOAD_START,
});

export const setAnnualRevenueDataForCalculator = (payload: number) => ({
  type: SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR,
  payload,
});

export const setMaxSampleRevenuePotentialPropertySize = (payload: number) => ({
  type: SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE,
  payload,
});

export const setCompsetListingIds = (payload: number[]) => ({
  type: GET_COMPSET_LISTING_IDS_LOAD_END,
  payload,
});

export const setUserCountryCode = (payload: string) => ({
  type: SET_USER_COUNTRY_CODE,
  payload,
});

export const setUserPrefCountryCode = (payload: string) => ({
  type: SET_USER_PREF_COUNTRY_CODE,
  payload,
});

export const setIsUserAllowed = payload => ({
  type: SET_IS_USER_ALLOWED,
  payload,
});

export const getNearbyRecommendedMarketsLoadingStart = () => ({
  type: GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START,
});

export const getNearbyRecommendedMarketsLoadingEnd = payload => ({
  type: GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END,
  payload,
});

export const setRevenuePotentialRange = payload => ({
  type: SET_REV_POTENTIAL_RANGE_INVESTMENT,
  payload,
});

export const setLeadFormSource = payload => ({
  type: SET_LEAD_FORM_SOURCE,
  payload,
});

export const setIndividualRevenuePotentialRange = (payload: {
  [key: number]: 'visible' | 'hidden';
}) => ({
  type: SET_INDIVIDUAL_REV_POTENTIAL_RANGE,
  payload,
});

export const setPriceTiers = (payload: number[]) => ({
  type: SET_PRICE_TIERS,
  payload,
});

export const updatePriceTiers = (payload: PriceTiers) => ({
  type: UPDATE_PRICE_TIERS,
  payload,
});

export const setBoundsMapInsights = (payload: Bounds) => ({
  type: SET_BOUNDS_MAP_INSIGHTS,
  payload: payload,
});

export const setFiltersInsights = payload => ({
  type: SET_FILTERS_INSIGHTS,
  payload: payload,
});

export const setFilterInsightsActive = payload => ({
  type: SET_FILTER_INSIGHTS_ACTIVE,
  payload: payload,
});

export const setVisibleListingIDs = payload => ({
  type: SET_VISIBLE_LISTING_IDS,
  payload: payload,
});

export const getVisibleMapSupplyLoadStart = () => ({
  type: GET_VISIBLE_MAP_SUPPLY_LOAD_START,
});

export const setVisibleMapSupply = payload => ({
  type: SET_VISIBLE_MAP_SUPPLY,
  payload: payload,
});

export const getHiddenSubmarketsLoadStart = () => ({
  type: GET_HIDDEN_SUBMARKETS_LOAD_START,
});

export const setHiddenSubmarkets = payload => ({
  type: SET_HIDDEN_SUBMARKETS,
  payload,
});

export const getDistrictInfo = (
  loginCountryCode: string,
  district: string,
  city: string,
  country: string,
  getMarketData = true,
  callMarketGrade = true,
  marketID: string | null = null
) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getSearchLoadStart());
  const {
    dashboard: { search, marketGrade },
  } = getState();
  const url = 'https://789ao60a9c.execute-api.us-east-2.amazonaws.com/prod/getMarketInfo';

  const config = {
    district: district,
    city: city,
    country: country,
  };

  if (marketID) {
    config.marketID = marketID;
  }

  try {
    const response = await api(url, { queryParams: config }, true);
    const districtObj = response.message;

    const country = districtObj['country'];
    const city = districtObj['city'];
    const district = districtObj['name'];
    const isUserAllowed = districtObj['isUserAllowed'];

    const newSearchObj = {
      name: district,
      lat: districtObj['lat'],
      lng: districtObj['lng'],
      polygon: districtObj['polygon'],
      multiPolygon: districtObj['multiPolygon'],
      city: city,
      country: country,
      countryCode: districtObj['countryCode'],
      bounds: convertBoundsArrayToObj(districtObj['bounds']),
      recommendPageURLs: districtObj['recommendPageURLs'],
      isTailoredRegion: districtObj['visibility'] == 'private' ? true : false,
      currency: districtObj['currency'],
      marketID: districtObj['marketID'],
      created_by: districtObj['created_by'],
      visibility: districtObj['visibility'],
      id: districtObj['id'],
      marketBlogLink: districtObj['marketBlogLink'],
      isUserAllowed: isUserAllowed,
      parentMarketID: districtObj['parentMarketID'],
      displayName: districtObj['displayName'],
      boundary: districtObj['boundary'],
      tier: districtObj['tier'],
      isVerifiedMarket: districtObj['isVerifiedMarket'] ?? false,
    };

    storeVisitedMarketInLocalStorage(newSearchObj);

    dispatch(setIsUserAllowed(isUserAllowed));

    if (!marketGrade.data && callMarketGrade) {
      dispatch(getMarketGrade(parseInt(newSearchObj.id)));
    }

    if (getMarketData) {
      dispatch(
        fetchCachedMarketData(
          newSearchObj.id,
          newSearchObj.name,
          newSearchObj.city,
          newSearchObj.countryCode,
          newSearchObj.country,
          loginCountryCode,
          true,
          newSearchObj.isVerifiedMarket ?? false
        )
      );
    }

    syncLocalstorageMarketSearchHistory(districtObj.id);

    dispatch(searchChange({ ...search, data: { ...search.data, ...newSearchObj } }));
    dispatch(getSearchLoadEnd());
  } catch (err) {
    console.log('Unhandled error while calling getDistrictInfo ', err);
    dispatch(getSearchLoadEnd());
  }
};

export const setTopHostsRateLimited = (payload: boolean) => ({
  type: SET_TOP_HOSTS_RATE_LIMITED,
  payload,
});

export const getTopHosts = (marketID: string) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(
    setTopHosts({
      data: null,
      loading: true,
      isUserAllowedToHostData: false,
      isRateLimited: false,
    })
  );

  const url = GET_TOP_HOST_DETAILS_URL;
  const config = {
    marketID: marketID,
    returnUserAccess: true,
    apiType: 'v3',
  };
  const response = await api(url, { queryParams: config }, true, true, '', 'GET', true, undefined, true, true);
  console.log('RESPONSE: ', response);

  if (response && response.status === 429) {
    dispatch(setTopHosts({
      data: null,
      loading: false,
        isUserAllowedToHostData: false,
        isRateLimited: true,
      })
    );
    return;
  }

  if (!response.message || response.error) {
    dispatch(
      setTopHosts({
        data: null,
        loading: false,
        isUserAllowedToHostData: false,
        isRateLimited: false,
      })
    );
    return;
  }

  dispatch(
    setTopHosts({
      data: response.message.hosts,
      loading: false,
      isUserAllowedToHostData: response.message.is_user_allowed,
      isRateLimited: false,
    })
  );
};

export const setTopHosts = (payload: any) => ({
  type: SET_TOP_HOSTS,
  payload,
});

const withTimeout = (promise, ms = 15000) =>
  Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error('Request timeout')), ms)),
  ]);

export const getTailoredRegionMarkers = (bounds, passMarketPolygon = false) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  const {
    dashboard: { search },
  } = getState();

  const url =
    'https://rd9s3wn350.execute-api.us-east-2.amazonaws.com/default/getMarkersTailorRegion';
  let markerParam = {};

  let marketBoundary = search.data.polygon;
  if (!marketBoundary) {
    marketBoundary = search.data.multiPolygon;
  }
  setMarkerParams(markerParam, bounds, passMarketPolygon ? marketBoundary : null);

  const response = await api(url, { queryParams: markerParam }, false);
  if (typeof response.message === 'string') {
    return;
  }

  const tailoredRegionMarkers = processTailoredRegionMarkers(response.message);
  dispatch(getTailoredRegionMarkersSuccess(tailoredRegionMarkers));
};

export const getReviewStream = () => async (dispatch: AppDispatch, getState, api) => {
  const url = 'https://x5cv061l6c.execute-api.us-east-2.amazonaws.com/default/getReviewStream';
  dispatch(getReviewStreamLoadStart());
  let {
    dashboard: { search },
  } = getState();

  let markerParam = { ...search.data };
  delete markerParam.polygon;
  delete markerParam.multiPolygon;
  delete markerParam.country;
  delete markerParam.lat;
  delete markerParam.lng;
  delete markerParam.zoom;
  delete markerParam.bounds;
  delete markerParam.isTailoredRegion;

  let auth = true;
  if (makeLowerCase(search.data.name) == sampleMarket) {
    auth = false;
  }
  const response = await api(url, { queryParams: markerParam }, auth);
  dispatch(getReviewStreamLoadEnd(response.message));
};

export const getUserInfo = () => async (dispatch: AppDispatch, __, api, _) => {
  const url = 'https://w1ec9zcvbk.execute-api.us-east-2.amazonaws.com/default/getUserInfo';
  const response = await api(url, {}, true);

  if (response && response.message) {
    let user: User = response.message;
    if (user == 'Failed to fetch' || user == 'Invalid Auth Token') {
      return;
    }
    const overviewFilters = user.overviewFilters ? JSON.parse(user.overviewFilters) : {};
    dispatch(setUserInfo({ ...user, loading: false }));
    !isEmpty(overviewFilters) && dispatch(setFiltersInsights(overviewFilters));
    if (user.subscriptionPlan === 'expert' || user.subscriptionPlan === 'scale') {
      dispatch(setIsUserAllowed(true));
    }
  }
};

export const searchChange = (payload: Search) => ({
  type: SEARCH_CHANGE,
  payload,
});

// TODO: Change this to fetch coordinates of city
export const getSearch = () => async (dispatch: AppDispatch) => {
  dispatch(getSearchLoadStart());

  dispatch(getSearchLoadEnd());
};

export const setCurrency = (payload: str) => ({
  type: SET_CURRENCY,
  payload,
});

export const getNearbyRecommendedMarkets = (
  searchedMarkets: any[],
  reqMarketsCount: number,
  lastPromise: React.MutableRefObject<any>
) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getNearbyRecommendedMarketsLoadingStart());
  try {
    const url =
      'https://pjm7yob50d.execute-api.us-east-2.amazonaws.com/default/getNearbyRecommendedMarkets';
    const config = {
      queryParams: {
        inputMarkets: JSON.stringify(searchedMarkets),
        number_of_return_markets: reqMarketsCount,
      },
    };

    const currentPromise = api(url, config, true).then(response => {
      return response;
    });
    lastPromise.current = currentPromise;

    currentPromise.then(
      response => {
        if (currentPromise === lastPromise.current) {
          dispatch(getNearbyRecommendedMarketsLoadingEnd(response));
        }
      },
      e => {
        if (currentPromise === lastPromise.current) {
          console.warn('fetch failure', e);
        }
      }
    );
  } catch (err) {
    console.error('Failed to fetch nearby markets!');
    dispatch(getNearbyRecommendedMarketsLoadingEnd([]));
  }
};

// bright pricing
const getUserAirbnbListingsLoadStart = () => ({
  type: GET_USER_AIRBNB_LISTINGS_LOAD_START,
});

const getUserAirbnbListingsLoadEnd = payload => ({
  type: GET_USER_AIRBNB_LISTINGS_LOAD_END,
  payload,
});

const getListingPricingRecommendationLoadStart = () => ({
  type: GET_LISTING_PRICING_RECOMMENDATION_LOAD_START,
});

const getListingPricingRecommendationLoadEnd = payload => ({
  type: GET_LISTING_PRICING_RECOMMENDATION_LOAD_END,
  payload,
});

export const getUserAirbnbListings = () => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getUserAirbnbListingsLoadStart());
  const url =
    'https://hilpzzpeo4.execute-api.us-east-2.amazonaws.com/default/getUserAirbnbListings';
  let userAirbnbListings = [];
  try {
    const response = await api(url, {}, true);
    userAirbnbListings = response.message;
    dispatch(getUserAirbnbListingsLoadEnd(userAirbnbListings));
  } catch (e) {
    console.log('error: ', e);
  }
};

export const getListingPricingRecommendation = (listingID: string, pushPricing: boolean) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  const url =
    'https://5v07hdzm7g.execute-api.us-east-2.amazonaws.com/default/getListingPricingRecommendation';
  try {
    if (pushPricing) {
      const response = await api(
        url,
        { queryParams: { listingID: listingID, pushPricing: true } },
        true
      );
    } else {
      dispatch(getListingPricingRecommendationLoadStart());
      const response = await api(url, { queryParams: { listingID: listingID } }, true);
      dispatch(getListingPricingRecommendationLoadEnd(response));
    }
  } catch (e) {
    console.log('error: ', e);
  }
};

export const setSearchLimitAlertBox = (payload: boolean) => ({
  type: SET_SEARCH_LIMIT_BOX_ALERT,
  payload,
});

const setGoogleAutocompleteSessionToken = payload => ({
  type: SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  payload: payload,
});

export const getGoogleAutocompleteSessionToken = loader => async (dispatch: AppDispatch) => {
  try {
    const google = !loader ? (window as any).google : await loader.load();
    if (!google?.maps?.places) {
      console.error('Google Maps Places library not loaded');
      return null;
    }
    const sessionToken = new google.maps.places.AutocompleteSessionToken();
    dispatch(setGoogleAutocompleteSessionToken(sessionToken));
    return sessionToken;
  } catch (e) {
    console.error('Failed to create AutocompleteSessionToken:', e);
    return null;
  }
};

export const clearGoogleAutocompleteSessionToken = () => ({
  type: EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
});

export const setHistoricalData = payload => ({
  type: SET_HISTORICAL_DATA,
  payload: payload,
});

export const fetchDemoHistoryFromS3 = async () => {
  const url = 'https://airbtics-resource.s3.us-east-2.amazonaws.com/demoGranularDataDaily.json';
  try {
    const result = await fetchMonthlyHistoricalData(url, false);
    return result;
  } catch (err) {
    console.log('Error while calling demo granularity data: ', err);
    return null;
  }
};

export const setCachedSearchMarkets = payload => ({
  type: GET_CACHED_SEARCH_MARKETS,
  payload,
});

export const setTop10MarketsCountryWise = payload => ({
  type: SET_TOP_10_MARKETS_COUNTRY_WISE,
  payload,
});

// FuseOptions, FuseResultWithMatches

export const getCachedSearchMarkets = () => async (dispatch: AppDispatch) => {
  const marketBuffer = await axios.get(
    'https://airbtics-resource.s3.us-east-2.amazonaws.com/public_markets_compressed_3.json.gz',
    {
      responseType: 'arraybuffer',
      decompress: true,
    }
  );
  let markets: CachedSearchedMarketsType[] = await JSON.parse(
    pako.inflate(marketBuffer.data, { to: 'string' })
  );

  markets = markets.map(market => ({
    ...market,
    searchName: removeAccent(market.displayName) || removeAccent(market.district),
  }));

  const fuse: Fuse<CachedSearchedMarketsType> = new Fuse(markets);

  dispatch(setCachedSearchMarkets({ fuse, markets }));
};

export const getTop10MarketCountryWise = () => async (dispatch: AppDispatch) => {
  try {
    const top10marketData = await axios.get(
      'https://airbtics-resource.s3.us-east-2.amazonaws.com/public_top_10_best_markets_country_wise.json'
    );
    dispatch(setTop10MarketsCountryWise(top10marketData.data));
  } catch (err) {
    console.error('Error while getting top 10 markets: ', err);
  }
};

export const setTopBannerOpen = (payload: boolean) => ({
  type: SET_TOP_BANNER_OPEN,
  payload,
});

export const setLockedMarketDummyData = (payload: any) => ({
  type: SET_LOCKED_MARKET_DUMMY_DATA,
  payload: payload,
});

export const setCachedMarketDataRateLimited = (payload: boolean) => ({
  type: SET_CACHED_MARKET_DATA_RATE_LIMITED,
  payload: payload,
});

export const fetchCachedMarketData = (
  marketID: string,
  name: string,
  city: string | 0,
  countryCode: string,
  country: string,
  loginCountryCode,
  shouldShowLoading = true,
  isVerifiedMarket: boolean = false,
  hardRefresh: boolean = false
) => async (dispatch: AppDispatch, getState, api) => {
  const URL =
    'https://43kxfqfm00.execute-api.us-east-2.amazonaws.com/default/getMarketDataCacheTest';
  const TIME_DURATION_TO_CALL_AGAIN = 5000; // in ms

  dispatch(setCachedMarketDataRateLimited(false));

  try {
    if (shouldShowLoading) dispatch(setCachedMarketDataLoading());

    const config: Record<string, string | number> = {
      market_id: marketID,
      name,
      city,
      countryCode,
      loginCountry: loginCountryCode,
      country,
      apiType: 'v3'
    };
    if (isVerifiedMarket !== undefined && isVerifiedMarket !== null) {
      config.isVerifiedMarket = isVerifiedMarket ? 'true' : 'false';
    }
    if (hardRefresh) {
      config.hard_refresh = 'true';
    }

    const response = await api(URL, { queryParams: config }, true, true, '', 'GET', true, undefined, true, true);

    if (response && response.status === 202) {
      return;
    }
    if (response && response.status === 429) {
      dispatch(setCachedMarketDataRateLimited(true));
      return;
    }

    /*
      cases
      -   if message is null means lambda failed (e.g. cors error)
      -  {"message": "Cache not found"}
      -  response.status === 404 (cache not ready yet, e.g. tailored region building)
    */
    if (
      !response ||
      typeof response == 'string' ||
      response.is_cache_outdated ||
      response.message == 'Cache not found' ||
      response.status === 404
    ) {
      /*
        Now, we are re-calling the API
      */
      let shouldShowLoadingDuringRetrying = true;
      const isCacheNotFound =
        response?.message === 'Cache not found' || response?.status === 404;
      const hasUsableData =
        response &&
        typeof response != 'string' &&
        !isCacheNotFound;
      if (hasUsableData) {
        const parsedMessage = parseMessageHistoricalData(response);
        dispatch(setCachedMarketData(parsedMessage));
        if (Array.isArray(parsedMessage?.price_tier_distribution) && parsedMessage.price_tier_distribution.length > 0) {
          dispatch(setPriceTiers(parsedMessage.price_tier_distribution));
        }
        shouldShowLoadingDuringRetrying = false;
      }
      /*
        Re-try only when we have no usable data (e.g. Cache not found, 404).
        Do not retry when we already dispatched setCachedMarketData (e.g. is_cache_outdated but valid payload).
      */
      if (!hasUsableData) {
        const isVerifiedFromSearch = (getState().dashboard?.search?.data as any)?.isVerifiedMarket ?? isVerifiedMarket;
        setTimeout(() => {
          dispatch(
            fetchCachedMarketData(
              marketID,
              name,
              city,
              countryCode,
              country,
              loginCountryCode,
              shouldShowLoadingDuringRetrying,
              isVerifiedFromSearch
            )
          );
        }, TIME_DURATION_TO_CALL_AGAIN);
      }
    } else {
      /*
        the API call was successful!
        cases
        -  {"message": "No active listings"}
      */
      let message = response?.message;
      if (message == 'No active listings') {
        dispatch(setCachedMarketData({}));
        dispatch(setIsCachedMarketDataSample(false));
      } else {
        const parsedMessage = parseMessageHistoricalData(response);
        dispatch(setCachedMarketData(parsedMessage));
        if (Array.isArray(parsedMessage?.price_tier_distribution) && parsedMessage.price_tier_distribution.length > 0) {
          dispatch(setPriceTiers(parsedMessage.price_tier_distribution));
        }
        dispatch(setIsCachedMarketDataSample(false));
      }
    }
  } catch (error) {
    console.error('Error fetching cached market data:', error);
  }
};

/**
 * Fire-and-forget: trigger backend listings refresh only. Does not dispatch any cache actions.
 * Returns a promise that resolves with { queued: true } when backend returns 202.
 */
export const triggerListingsRefresh = (
  marketID: string,
  name: string,
  city: string | 0,
  countryCode: string,
  country: string,
  loginCountryCode: string,
  isVerifiedMarket: boolean = false
) => async (dispatch: AppDispatch, getState, api) => {
  const URL =
    'https://43kxfqfm00.execute-api.us-east-2.amazonaws.com/default/getMarketDataCacheTest';
  const config: Record<string, string | number> = {
    market_id: marketID,
    name,
    city,
    countryCode,
    loginCountry: loginCountryCode,
    country,
    apiType: 'v3',
    hard_refresh: 'true',
  };
  if (isVerifiedMarket !== undefined && isVerifiedMarket !== null) {
    config.isVerifiedMarket = isVerifiedMarket ? 'true' : 'false';
  }
  try {
    const response = await api(URL, { queryParams: config }, true, true, '', 'GET', true, undefined, true, true);
    return { queued: response?.status === 202 };
  } catch (error) {
    console.error('Error triggering listings refresh:', error);
    return { queued: false };
  }
};

export const setCachedMarketDataLoading = () => ({
  type: GET_MARKET_CACHED_DATA,
});

export const setCachedMarketData = (payload: any) => ({
  type: SET_MARKET_CACHED_DATA,
  payload: payload,
});

export const setIsCachedMarketDataSample = (payload: boolean) => ({
  type: SET_IS_CACHED_MARKET_DATA_SAMPLE,
  payload: payload,
});

export const setMarketDashboardFilter = (payload: FilteredListingsDashboardDataType) => ({
  type: SET_MARKET_DASHBOARD_FILTER_DATA,
  payload,
});

const getExplorerMarketsLoadStart = () => ({
  type: GET_EXPLORER_MARKETS,
});

export const setExplorerMarkets = payload => ({
  type: SET_EXPLORER_MARKETS,
  payload,
});

export const getExplorerMarkets = (countryCode: string, marketType: string = 'market') => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getExplorerMarketsLoadStart());
  const url = 'https://t15cs2r44j.execute-api.us-east-2.amazonaws.com/default/getMarkets';
  let queryParams = {};
  if (countryCode == 'saved') {
    queryParams = { savedMarkets: true };
  } else {
    queryParams = { countryCode: countryCode, marketType: marketType };
  }
  const response = await api(url, { queryParams: queryParams }, true, true);
  dispatch(setExplorerMarkets(response.message.markets));
};

export const deductEstimatorCreditAction = payload => ({
  type: DEDUCT_ESTIMATOR_CREDIT,
});

export const setUserAsVerified = () => ({
  type: SET_USED_VERIFIED,
});

export const setMapListingsRateLimited = (payload: boolean) => ({
  type: SET_MAP_LISTINGS_RATE_LIMITED,
  payload: payload,
});

export const fetchVisibleMapSupply = (
  marketID: number | string,
  marketBoundary: string,
  bounds: Bounds,
  filters: any,
  sortBy: string
) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getVisibleMapSupplyLoadStart());
  const {
    dashboard: { search },
  } = getState();

  // const url = 'https://fytwsbtpl2.execute-api.us-east-2.amazonaws.com/default/getDynamicSupply';
  const url = 'https://xnxq16nesj.execute-api.us-east-2.amazonaws.com/default/getMapListings';
  const requestBody = {
    neLat: bounds.northEast.lat,
    neLng: bounds.northEast.lng,
    swLat: bounds.southWest.lat,
    swLng: bounds.southWest.lng,
    market_id: marketID,
    return_supply: true,
    marketPolygon: marketBoundary,
    sort_by: sortBy,
  };

  if (!isEmpty(filters)) {
    requestBody['filters'] = filters;
  }

  let supply = 0;

  dispatch(setMapListingsRateLimited(false));

  try {
    const response = await callApi(
      url,
      { body: requestBody, queryParams: { apiType: 'v2' } },
      true,
      false,
      '',
      'POST',
      true,
      undefined,
      true,
      true
    );

    if (response && response.status == 429) {
      dispatch(setVisibleMapSupply(0));
      dispatch(setMapListingsRateLimited(true));
      return;      
    }

    if (response && response.message) {
      supply = response.message.supply;
      dispatch(setVisibleMapSupply(supply));
    }
  } catch (error) {
    console.error('Error fetching dynamic supply:', error);
  }
};

export const getHiddenSubmarkets = (marketID: number) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  const url =
    'https://e40preul0i.execute-api.us-east-2.amazonaws.com/default/setUserSubmarketVisibility';
  const requestBody = {
    market_id: marketID,
    action: 'get',
  };

  try {
    dispatch(getHiddenSubmarketsLoadStart());
    const response = await callApi(url, { body: requestBody }, true, false, '', 'POST', true);
    if (response && response.message) {
      dispatch(setHiddenSubmarkets(response.message));
    }
  } catch (error) {
    console.error('Error fetching hidden submarkets:', error);
  }
};

export const getUpdatedSubMarketsToHide = (
  hiddenSubmarkets: string[],
  submarketIDs: string[],
  action: 'hide' | 'show' | 'show_all'
) => {
  if (action == 'hide') {
    return Array.from(new Set([...hiddenSubmarkets.data, ...submarketIDs])).map(String);
  } else if (action == 'show') {
    return [...hiddenSubmarkets.data].filter(id => !submarketIDs.includes(String(id)));
  } else if (action == 'show_all') {
    return [];
  }
};

export const updateHiddenSubmarketsLocally = (
  submarketIDs: string[],
  action: 'hide' | 'show' | 'show_all'
) => async (dispatch: AppDispatch, getState, api) => {
  const hiddenSubmarkets = getState().dashboard.hiddenSubmarkets;
  dispatch(setHiddenSubmarkets(getUpdatedSubMarketsToHide(hiddenSubmarkets, submarketIDs, action)));
};

export const toggleSubmarketVisibility = (
  marketID: number,
  submarketIDs: string[],
  action: 'hide' | 'show' | 'show_all',
  callback?: (state: 'success' | 'error') => void
) => async (dispatch: AppDispatch, getState, api) => {
  const url =
    'https://e40preul0i.execute-api.us-east-2.amazonaws.com/default/setUserSubmarketVisibility';

  const hiddenSubmarkets = getState().dashboard.hiddenSubmarkets;
  const submarketsToUpdate = getUpdatedSubMarketsToHide(
    hiddenSubmarkets,
    submarketIDs.map(String),
    action
  );

  const requestBody = {
    market_id: marketID,
    action: action,
    submarket_ids: submarketsToUpdate,
  };
  try {
    dispatch(updateHiddenSubmarketsLocally(submarketIDs.map(String), action));
    await callApi(url, { body: requestBody }, true, false, '', 'POST', true);

    callback && callback('success');
  } catch (error) {
    console.error('Error toggling submarket visibility:', error);
    callback && callback('error');
  }
};

const getClustersLoadStart = () => ({
  type: GET_CLUSTERS_LOAD_START,
});

const getClustersLoadEnd = (payload: any[]) => ({
  type: GET_CLUSTERS_LOAD_END,
  payload,
});

export const getClusters = (marketID: string) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getClustersLoadStart());
  const url = 'https://a1nl3szhnj.execute-api.us-east-2.amazonaws.com/default/getClusters';
  const config = {
    market_id: marketID,
  };

  let retryCount = 0;
  const maxRetries = 10;
  const retryDelay = 3000;

  try {
    while (retryCount < maxRetries) {
      const response = await api(url, { queryParams: config }, false);
      if (response && response.message) {
        const clusterStatus = response.message.cluster_status || null;
        if (clusterStatus && clusterStatus == 'processing') {
          await new Promise(resolve => setTimeout(resolve, retryDelay));
          retryCount++;
          continue;
        } else {
          dispatch(getClustersLoadEnd(response.message.clusters));
          break;
        }
      } else {
        dispatch(getClustersLoadEnd([]));
        break;
      }
    }

    if (retryCount === maxRetries) {
      console.error('Max retries reached, no clusters ready');
      dispatch(getClustersLoadEnd([]));
    }
  } catch (error) {
    console.error('Error fetching clusters:', error);
    dispatch(getClustersLoadEnd([]));
  }
};

export const getMarketCachedDataWithFilters = () => ({
  type: GET_MARKET_CACHED_DATA_WITH_FILTERS,
});

export const setMarketCachedDataWithFilters = payload => ({
  type: SET_MARKET_CACHED_DATA_WITH_FILTERS,
  payload,
});

export const setNoDataWithCurrentFilter = (payload: boolean) => ({
  type: SET_NO_DATA_WITH_CURRENT_FILTER,
});

const getMapOverviewKpiLoadStart = () => ({
  type: GET_MAP_OVERVIEW_KPI_LOAD_START,
});

const setMapOverviewKpi = (payload: any) => ({
  type: SET_MAP_OVERVIEW_KPI,
  payload,
});

export const getMapOverviewKpi = (
  marketID: number | string,
  marketBoundary: string,
  bounds: Bounds,
  filters: any
) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getMapOverviewKpiLoadStart());

  const url = 'https://1dqvbuqb3a.execute-api.us-east-2.amazonaws.com/default/getMapOverview';
  const requestBody = {
    neLat: bounds.northEast.lat,
    neLng: bounds.northEast.lng,
    swLat: bounds.southWest.lat,
    swLng: bounds.southWest.lng,
    market_id: marketID,
    marketPolygon: marketBoundary,
  };

  if (!isEmpty(filters)) {
    requestBody['filters'] = filters;
  }

  try {
    const response = await callApi(url, { body: requestBody }, false, false, '', 'POST', true);
    if (response && response.message) {
      dispatch(setMapOverviewKpi(response.message));
    }
  } catch (error) {
    console.error('Error fetching map overview kpi:', error);
    dispatch(
      setMapOverviewKpi({
        supply: null,
        adr: null,
        occupancy_rate: null,
        revenue: null,
      })
    );
  }
};

// Saved Markets Action Creators
export const setSelectedListAction = (payload: any) => ({
  type: SET_SELECTED_LIST,
  payload,
});

export const setLastSavedMarketNamesAction = (payload: string[]) => ({
  type: SET_LAST_SAVED_MARKET_NAMES,
  payload,
});

export const setOpenSavedMarketsCTAModalAction = (payload: string | false) => ({
  type: SET_OPEN_SAVED_MARKETS_CTA_MODAL,
  payload,
});

export const setSelectedListLoadingAction = (payload: boolean) => ({
  type: SELECTED_LIST_LOADING,
  payload,
});

export const setSelectedListErrorAction = (payload: boolean) => ({
  type: SET_SELECTED_LIST_ERROR,
  payload,
});

const SAVED_MARKETS_API_URL =
  'https://dl57s3go31.execute-api.us-east-2.amazonaws.com/default/handleSavedMarkets';

// Utility function to create a list (internal to this module)
export const createListAPI = async (
  listName: string,
  userSignupCountryCode: string | undefined = undefined
) => {
  try {
    const requestBody = {
      name: listName,
    };

    if (userSignupCountryCode) {
      requestBody['user_signup_country_code'] = userSignupCountryCode;
    }

    const response = await callApi(
      SAVED_MARKETS_API_URL,
      {
        body: requestBody,
      },
      true, // auth
      false, // gzip
      '', // key
      'POST', // method
      true // returnErrorJson
    );

    if (response.message) {
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error while creating a list: ', error);
    return false;
  }
};

// Thunk to fetch all lists
export const fetchAllLists = (retries: number = 0) => async (dispatch: AppDispatch, getState) => {
  const {
    dashboard: {
      user: { signupCountryCode },
    },
  } = getState();

  if (retries > 2) {
    dispatch(setSelectedListErrorAction(true));
    return null;
  }

  try {
    const response = await callApi(SAVED_MARKETS_API_URL, {}, true, false, '', 'GET', true);

    if (response.error || !response.lists) {
      console.error('Error: GET ALL LISTS:  ', response.error);
      return dispatch(fetchAllLists(retries + 1));
    }

    if (response.lists) {
      const lists = response.lists;
      if (lists.length === 0) {
        const createdList = await createListAPI('default', signupCountryCode);
        console.log('Created list: ', createdList);
        return dispatch(fetchAllLists(retries + 1));
      }
      dispatch(setAllSavedMarketListsAction(lists));
      return lists;
    }
    return [];
  } catch (error) {
    console.error('Error while fetching all lists: ', error);
    return dispatch(fetchAllLists(retries + 1));
  }
};

// Thunk to fetch details of the default list
export const fetchDefaultListDetails = (
  lists: any[],
  retries: number = 0,
  selectedBedrooms: string | null = null,
  listID: string | null = null
) => async (dispatch: AppDispatch) => {
  if (lists === null) {
    dispatch(setSelectedListErrorAction(true));
    return null;
  }

  if (retries > 2) {
    dispatch(setSelectedListErrorAction(true));
    return null;
  }

  const lastSelectedMarketListId = localStorage.getItem(LAST_SELECTED_MARKET_LIST_ID);

  let defaultListFromAllLists = lists.find(list =>
    listID
      ? list.list_id === listID
      : lastSelectedMarketListId
      ? list.list_id === lastSelectedMarketListId
      : list.is_default
  );

  if (!defaultListFromAllLists) {
    console.warn('No default list found. Attempting to use the first list or handle error.');
    if (lists.length > 0) {
      defaultListFromAllLists = lists[0];
      console.warn('Using first available list as default: ', defaultListFromAllLists.list_name);
    } else {
      console.error('No lists available to select a default.');
      dispatch(setSelectedListErrorAction(true));
      return null;
    }
  }

  const listId = defaultListFromAllLists.list_id;
  const listName = defaultListFromAllLists.list_name;

  const queryParams = {
    list_id: listId,
  };

  if (selectedBedrooms) {
    queryParams['bd_filter'] = selectedBedrooms;
  }

  try {
    const defaultListResponse = await callApi(
      SAVED_MARKETS_API_URL,
      { queryParams },
      true,
      false,
      '',
      'GET',
      true
    );

    if (defaultListResponse.error || !defaultListResponse.list_id) {
      console.error(`Error fetching details for list ID ${listId}:`, defaultListResponse.error);
      return dispatch(fetchDefaultListDetails(lists, retries + 1, selectedBedrooms));
    }

    const listData = {
      id: String(listId),
      name: listName,
      marketIDs: defaultListResponse.market_data || {},
      marketDetails: defaultListResponse.market_data || {},
    };

    dispatch(
      setSelectedListAction({
        id: listData.id,
        name: listData.name,
        marketIDs: listData.marketDetails
          ? Object.keys(listData.marketDetails).reduce((acc, id) => {
              acc[id] = 'saved';
              return acc;
            }, {})
          : {},
        marketDetails: listData.marketDetails,
      })
    );

    const currentMarketNames = Object.values(listData.marketDetails || {})
      .map((m: any) => m.name)
      .sort();
    dispatch(setLastSavedMarketNamesAction(currentMarketNames));
    dispatch(setOpenSavedMarketsCTAModalAction(false));

    localStorage.setItem(LAST_SELECTED_MARKET_LIST_ID, listId);

    return listData; // Return for potential chaining or direct use, though store is updated
  } catch (error) {
    console.error(`Error fetching details for list ID ${listId}:`, error);
    return dispatch(fetchDefaultListDetails(lists, retries + 1, selectedBedrooms));
  }
};

// Orchestrating thunk for initial saved markets data load
export const initializeSavedMarketsData = () => async (dispatch: AppDispatch) => {
  dispatch(setSelectedListLoadingAction(true));
  try {
    const allLists = await dispatch(fetchAllLists());
    if (allLists && allLists.length > 0) {
      await dispatch(fetchDefaultListDetails(allLists));
    } else if (allLists === null) {
      // Error case from fetchAllLists
      // setSelectedListErrorAction(true) is already dispatched by fetchAllLists in error cases
    } else {
      // No lists found and no default created, or empty array returned
      dispatch(
        setSelectedListAction({ id: null, name: 'default', marketIDs: {}, marketDetails: {} })
      ); // Set a default empty state
      dispatch(setSelectedListErrorAction(false)); // No error, just no lists
    }
  } catch (error) {
    console.error('Error initializing saved markets data: ', error);
    dispatch(setSelectedListErrorAction(true));
  } finally {
    dispatch(setSelectedListLoadingAction(false)); // Ensure loading is set to false
  }
};

// Thunk to update a market in a list
export const updateMarketInList = (
  currentListObject: {
    id: string;
    name: string;
    marketIDs: { [key: string]: 'saved' | 'saving' | null };
    marketDetails: any;
  },
  market_id: string | number,
  action: 'add' | 'remove',
  marketName: string | undefined,
  reloadListData: boolean = false
) => async (dispatch: AppDispatch, getState) => {
  const listWithSavingState = deepCopyObject(currentListObject);
  if (!listWithSavingState.marketIDs) listWithSavingState.marketIDs = {};
  listWithSavingState.marketIDs[market_id] = 'saving';
  dispatch(setSelectedListAction(listWithSavingState));

  const body: any = {
    market_id: market_id,
    action: action,
  };
  if (currentListObject.id) {
    body.list_id = currentListObject.id;
  }

  if (reloadListData) {
    dispatch(setSelectedListLoadingAction(true));
  }

  enqueueMarketUpdateRequest(
    body,
    market_id,
    action,
    currentListObject,
    marketName,
    dispatch,
    getState
  );
};

const updateMarketQueue = new FIFOAsyncQueue();

const enqueueMarketUpdateRequest = (
  body: any,
  market_id: string | number,
  action: 'add' | 'remove',
  currentListObject: any,
  marketName: string | undefined,
  dispatch: AppDispatch,
  getState: () => any
) => {
  updateMarketQueue.enqueue(async () => {
    try {
      const response = await callApi(SAVED_MARKETS_API_URL, { body }, true, false, '', 'PUT', true);

      if (
        response &&
        response.market_ids &&
        ((response.market_ids.includes(Number(market_id)) && action === 'add') ||
          (!response.market_ids.includes(Number(market_id)) && action === 'remove'))
      ) {
        const {
          dashboard: {
            savedMarkets: { data: currentListObject },
          },
        } = getState();

        const finalListState = deepCopyObject(currentListObject);
        finalListState.marketIDs[market_id] = action === 'add' ? 'saved' : null;

        if (action === 'add' && response.market_data) {
          finalListState.marketDetails = response.market_data;
        } else if (action === 'remove') {
          delete finalListState.marketDetails[market_id];
        }

        dispatch(setSelectedListAction(finalListState));

        const currentMarketNames = Object.values(finalListState.marketDetails || {})
          .map((m: any) => m.name)
          .sort();
        dispatch(setLastSavedMarketNamesAction(currentMarketNames));

        if (
          action === 'add' &&
          marketName &&
          currentMarketNames.length >= SAVED_MARKETS_POPUP_MESSAGE_THRESHOLD
        ) {
          dispatch(setOpenSavedMarketsCTAModalAction(marketName));
        } else {
          dispatch(setOpenSavedMarketsCTAModalAction(false));
        }
      } else {
        console.warn('API failed or inconsistent response', response);
        dispatch(setSelectedListAction(currentListObject));
      }
    } catch (err) {
      console.error('Error in queued API call:', err);
      dispatch(setSelectedListAction(currentListObject));
    }
  });
};

export const setAllSavedMarketListsAction = (payload: any[]) => ({
  type: SET_ALL_SAVED_MARKET_LISTS,
  payload,
});

export const setAllSavedMarketListsLoadingAction = (payload: boolean) => ({
  type: SET_ALL_SAVED_MARKET_LISTS_LOADING,
  payload,
});

export const updateListMarketsCountInAllSavedMarketListsAction = (payload: {
  listId: number;
  count: number;
}) => ({
  type: UPDATE_LIST_MARKETS_COUNT_IN_ALL_SAVED_MARKET_LISTS,
  payload,
});

export const updateUserExplorerPageRowDataExportUsageAction = (payload: number) => ({
  type: UPDATE_USER_MARKET_EXPLORER_ROW_DATA_EXPORT_USAGE,
  payload,
});

// Market Grade Actions
export const getMarketGradeLoadStart = () => ({
  type: GET_MARKET_GRADE_LOAD_START,
});

export const setMarketGrade = (payload: any) => ({
  type: SET_MARKET_GRADE,
  payload,
});

export const setMarketGradeError = () => ({
  type: SET_MARKET_GRADE_ERROR,
});

export const setMarketGrade404Error = () => ({
  type: SET_MARKET_GRADE_404_ERROR,
});

export const getMarketGrade = (marketID: number) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getMarketGradeLoadStart());
  try {
    const url = `https://jrw9pym4k6.execute-api.us-east-2.amazonaws.com/prod/getMarketGrade`;
    const response = await api(
      url,
      { queryParams: { market_id: marketID, apiType: 'v2' } },
      true,
      false,
      '',
      'GET',
      true,
      undefined,
      true,
      true
    );

    if (response && response.market_grade && response.market_summary) {
      dispatch(setMarketGrade(response));
    } else if (response && response.status === 429) {
      dispatch(setMarketGrade404Error());
    } else if (response && response.message === 'Market grade not found') {
      dispatch(setMarketGrade404Error());
    } else {
      dispatch(setMarketGradeError());
    }
  } catch (error) {
    console.error('Error fetching market grade:', error);
    dispatch(setMarketGradeError());
    dispatch(setMarketGrade(null));
  }
};

export const updateUserMarketSummaryPDFExportUsageAction = (payload: number) => ({
  type: UPDATE_USER_MARKET_SUMMARY_PDF_EXPORT_USAGE,
  payload,
});

export const getMarketsInMapViewportLoadStart = () => ({
  type: GET_MARKETS_IN_MAP_VIEWPORT_LOAD_START,
});

export const setMarketsInMapViewport = (payload: MarketInMapViewport[]) => ({
  type: SET_MARKETS_IN_MAP_VIEWPORT,
  payload,
});

export const getMarketsInMapViewport = (bounds: Bounds) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getMarketsInMapViewportLoadStart());
  try {
    const url = 'https://79s4j8s969.execute-api.us-east-2.amazonaws.com/prod/getMarketsByBoundary';
    const requestBody = {
      bounds: {
        sw_lat: bounds.southWest.lat,
        sw_lng: bounds.southWest.lng,
        ne_lat: bounds.northEast.lat,
        ne_lng: bounds.northEast.lng,
      },
    };
    const response = await callApi(url, { body: requestBody }, false, false, '', 'POST');
    if (response && response.markets) {
      dispatch(setMarketsInMapViewport(response.markets as MarketInMapViewport[]));
    } else {
      dispatch(setMarketsInMapViewport([]));
    }
  } catch (error) {
    console.error('Error fetching markets in map viewport:', error);
    dispatch(setMarketsInMapViewport([]));
  }
};

export const setTailoredRegionCreationRateLimited = (payload: boolean) => ({
  type: SET_TAILORED_REGION_CREATION_RATE_LIMITED,
  payload,
});

export const setLastPerformanceProcessedMonth = (payload: string) => ({
  type: SET_LAST_PERFORMANCE_PROCESSED_MONTH,
  payload,
});


export const getLastPerformanceProcessedMonth = () => async (dispatch: AppDispatch, getState, api) => {
  const LAST_PERFORMANCE_PROCESSED_MONTH_API_URL = "https://lr9npziar7.execute-api.us-east-2.amazonaws.com/Stage/last-processed-month"
  try {
    const response = await callApi(LAST_PERFORMANCE_PROCESSED_MONTH_API_URL, {}, false, false, '', 'GET', true, undefined, true, true);
    if (response && response.latest_calendar_processed) {
      console.log('last performance processed month:', response.latest_calendar_processed);
      dispatch(setLastPerformanceProcessedMonth(response.latest_calendar_processed));
      return response.latest_calendar_processed;
    }
  } catch (error) {
    console.error('Error fetching last performance processed month:', error);
    return null;
  }
};
